<template>
	<div>
		<div class="container">
			<div class="d-flex d-flex justify-content-between">
        <div class="input-group col-8 px-0 py-2">
          <!-- Button Group - Zurück & Ausloggen-->
          <div class="input-group-prepend">
            <b-btn
              class="btn btn-outline-secondary my-1"
              variant="btn-outline-secondary"
              @click="window.history.back();"
            >Zurück</b-btn>
          </div>
          <!-- Logout Button-->
          <div class="input-group-append">
            <b-btn
              class="btn btn-outline-secondary my-1"
              variant="btn-outline-primary"
              @click="window.location = '/logoutandredirecttostockscan'"
            >{{user}} ausloggen<span v-if="userCanDoEverything" class="ml-1 icon icon-shield" style="font-size: 1.5em;color:#ff8700;" title="Sie haben Master Berechtigungen."/></b-btn>
          </div>
        </div>
				<h3 class="my-0 py-2">Erfassung {{ passedWarehouseVendor.name }}</h3>
			</div>
			<div class="input-group input-group-lg pb-1">
				<input type="text"
					style="text-align: right;"
					:class="{'form-control': true, 'bg-info': (state == 1), 'bg-danger': ((state == 2) || (storability.hasCustomerOrderItem == false))}"
					placeholder="EAN"
					required
					v-model="scannedEan"
					ref="refEan"
					onClick="this.select()"
					@keypress.enter="goToVendor()"
				>
			</div>
			<!-- :class="{'form-control': true, 'col-6': true, 'bg-warning': !_.has(passedVendors, vendorSelected) && vendorSelected == ''}" -->
			<div class="input-group input-group-lg pb-1" v-if="passedWarehouseVendor.id == 6">
				<input
					id="vendor"
					type="text"
					style="text-align: right;"
					:class="{'form-control': true, 'col-6': true, 'bg-warning': (vendorSelected == '' || vendorSelected == null) && (!((!userCanDoEverything) && (storability.state > 1))) }"
					:disabled="(!userCanDoEverything) && (storability.state > 1)"
					placeholder="Vendor ID"
					ref="vendor"
					v-model="vendorSelected"
				>

				<label
					:disabled="(!userCanDoEverything) && (storability.state > 1)"
					class="form-control col-6"
					style="background-color: #ebeef0;"
				>
					{{selectedVendor?.name}}
				</label>
			</div>

			<div id="condition" class="input-group input-group-lg pb-1">
				<b-form-select
				:class="{'float-right': true, 'bg-info': conditionNotSelected}"
				:disabled="(!userCanDoEverything) && (storability.state > 1)"
				v-model="condition"
				:options="conditions"
				v-on:select="() => {conditionNotSelected = false}"
				></b-form-select>
			</div>

			<div class="input-group input-group-lg pb-1">
				<input
					id="qty"
					type="text"
					style="text-align: right;"
					class="form-control"
					:disabled="(!userCanDoEverything) && (storability.state > 1)"
					placeholder="Menge"
					v-model="quantity"
					@click="quantityClicked"
				>
			</div>

			<div class="input-group input-group-lg pb-1">

				<div class="input-group-prepend">
					<button class="btn btn-outline-secondary btn-sm" type="button" @click="() => {modalFav.state = true}"><span class="icon icon-star-empty mx-auto"></span></button>
				</div>

				<input
					type="text"
					style="text-align: right;"
					class="form-control"
					:disabled="(!userCanDoEverything) && (storability.state > 1)"
					placeholder="Bemerkung"
					v-model="comment"
					ref="refComment"
					onClick="this.select()"
				>
			</div>

			<div class="input-group input-group-lg pb-1">
				<b-input
					type="text"
					style="text-align: right;"
					:disabled="(!userCanDoEverything) && (storability.state > 1)"
                    :class="{
                       'form-control': true
                     , 'error-border': validateStockyard
                    }"
					placeholder="Lagerplatz"
					required
					v-model="stockyard"
					onClick="this.select()"
					@keypress.enter="save()"
				/>
			</div>

			<div class="py-2">

				<button v-if="scannedEan == '' || scannedEan == null"
					class="input-group-append btn btn-lg btn-secondary btn-block  mb-1 float-right"
					style="padding-top: 5px; height: 85px;"
					disabled
				>
                    <b-col class="m-3 p-3">
                        <b-row>
        					<span class="icon icon-minus mx-auto"></span>
                        </b-row>
                        <b-row/>
                    </b-col>
				</button>

				<!--button v-else-if="storability.state == 0 && vendorSelected == null"
					class="input-group-append btn btn-lg btn-warning btn-block  mb-1 float-right"
					style="padding-top: 5px; height: 85px;"
				>
					<span class="icon icon-minus mx-auto">&nbsp; Händler wählen</span>
				</button -->

				<button v-else-if="storability.state == 0"
					class="input-group-append btn btn-lg btn-warning btn-block  mb-1 float-right"
					style="padding-top: 5px; height: 85px;"
				>
                    <b-col class="m-3 p-3">
                        <b-row>
                            <span class="spinner-border spinner-border-sm mx-auto" role="status" aria-hidden="true">
                                <span class="sr-only">Loading...</span>
                            </span>
                            </b-row>
                        <b-row/>
                    </b-col>
				</button>

				<!-- normal mode -->

				<button v-else-if="(!userCanDoEverything) && (storability.state != 1)"
					class="input-group-append btn btn-lg btn-danger btn-block  mb-1 float-right"
					style="padding-top: 5px; height: 85px;"
					@click="wipe()"
				>
                    <b-col class="m-3 p-3">
                        <b-row>
                            <span v-if="storability.state == 2" class="icon icon-cross mx-auto">&nbsp; Nicht gefunden</span>
                            <span v-else-if="storability.state == 3" class="icon icon-cross mx-auto">&nbsp; Gesperrt</span>
                            <span v-else-if="storability.state == 4" class="icon icon-cross mx-auto">&nbsp; Noch nie verkauft</span>
                        </b-row>
                        <b-row/>
                    </b-col>
				</button>

				<!-- manager mode -->

				<button v-else-if="userCanDoEverything && (storability.state != 1)"
					class="input-group-append btn btn-lg btn-danger btn-block  mb-1 float-right"
					style="padding-top: 5px; height: 85px;"
					@click="save()"
				>
                    <b-col class="m-3 p-3">
                        <b-row>
                            <span v-if="storability.state == 2" class="icon icon-cross mx-auto">&nbsp; Nicht gefunden</span>
                            <span v-else-if="storability.state == 3" class="icon icon-cross mx-auto">&nbsp; Gesperrt</span>
                            <span v-else-if="storability.state == 4" class="icon icon-cross mx-auto">&nbsp; Noch nie verkauft</span>
                        </b-row>
                        <b-row/>
                    </b-col>
				</button>

				<button
					v-else-if="storability.state == 1"
					type="button"
					class="input-group-append btn btn-lg btn-primary btn-block  mb-1 float-right"
					:disabled="(!userCanDoEverything) && (storability.state != 1)"
					style="padding-top: 5px; height: 85px;"
					@click="save()"
				>
                    <b-col class="m-3 p-3">
                        <b-row>
                            <span class="icon icon-checkmark mx-auto"></span>
                        </b-row>
                        <b-row/>
                    </b-col>
				</button>
			</div>
		</div>

		<!--div v-else class="spinner-border m-5" role="status" style="display: block;position: fixed;z-index: 1031;top: 35%;right: 35%">
			<span class="sr-only">Loading...</span>
		</div -->

		<div><!-- Comment Favs Modal -->
			<b-modal v-model="modalFav.state" centered @blur="() => {modalFav.state = false}">
				<div slot="modal-header" class="w-100">
					<font size="+1"><b>Schnellauswahl: Beschreibungen</b></font>
				</div>

				<b-btn
					v-for="(c, idx) in modalFav.quickComments"
					size="lg"
					class="bg-white col-12 my-1"
					@click="() => {comment = c; modalFav.state = false;}"
					v-bind:key="idx"
				><font color="black">"{{c}}"</font></b-btn>

				<div slot="modal-footer"></div>

			</b-modal>
		</div>

	</div>
</template>
<style scoped>
.error-border {
   border: 4px solid red!important;
   background-color: #FFCCCC!important;
}
</style>
<script>
    export default {
        props: ['passedVendors', 'passedUser', 'passedWarehouseVendor' ],
            data() {
                return {
                    markets: [],
                    user: this.passedUser.user,
                    userCanDoEverything: false,
                    vendorSelected: '',
                    state: null, // 0: normal, 1: yellow (found element in db), TODO: 2: green found elem in db and it has >0 Bestellungen
                    scannedEan: '',
                    materialId: null,
                    quantity: null,
                    stockyard: null,
                    comment: null,
                    df: null,
                    vendor: {
                        data: this.passedVendors,
                        options: null,
                        //selected: null,
                        lastSelected: null,
                    },
                    modalFav: {
                        state: false,
                        quickComments: {
                            0: "Geschenk",
                            1: "Ladenpreis kleiner als 10€",
                            2: "Für beschädigten Artikel bestellt",
                            3: "Frist abgelaufen",
                            4: "Lager 4",
                            5: "Ausgeschlossen von Retouren",
                            6: "Steht auf wartet",
                            7: "Teuer",
                        }
                    },

                    condition: 1,
                    conditionNotSelected: true,
                    conditions: {
                        1: "NEU",
                        2: "SH",
                        3: "SHY"
                    },
                    storability: {
                        materialId: null,
                        additional: false,
                        hasCustomerOrderItem: "unknown",
                        state: 0
                    }
                }
            },
        methods: {
            quantityClicked()
            {
                if(this.quantity == null || this.quantity ==  '')
                {
                    this.quantity = 1
                };

                //this.$refs["quantity"][0].select();
                Vue.nextTick(
                    () => {
                        //this.$refs.refQuantity.select();
                    }
                );
            },

            goToVendor()
            {
                this.$refs.vendor.select();
            },
			isMaterialStorable() { // i.e. "darf der Artikel eingelagert werden"
                return new Promise( (resolve, reject) => {
                    this.storability = {
                        materialId: null,
                        productId: null,
                        additional: false,
                        hasCustomerOrderItem: "unknown",
                        state: 0,
                        stockyard : null,
                    };
                    axios.get('/material/temporarily_storable/' + this.scannedEan + '/' + this.condition + '/warehouse/' + this.passedWarehouseVendor.id)
                    .then( materialResponse => {
                        console.log("isMaterialStorable response");
                        console.log(materialResponse.data);
                        this.storability = materialResponse.data;
                        axios.get('/mds/blocker_computed/' + this.storability.productId).then( blockerComputedResponse => {
                            //check if all blockerComputeds exist and are all Blacklist entries...
                            let isBlocked = this.markets.reduce((otherMarkets, market) => {
                                let blockerComputed = blockerComputedResponse.data.find( b => b.marketId === market.id )
                                if(!blockerComputed) return false;
                                return otherMarkets && blockerComputed.blackOrWhite;
                            }, true);
                            if(isBlocked)
                            {
                                this.storability.state = 3;
                                this.storability.hasCustomerOrderItem = "unknown";
                            }
                            else if (this.passedWarehouseVendor.id != 6)
                            {
                                this.storability.state = 1;
                                this.storability.hasCustomerOrderItem = "unknown";
                            }
                            
                            setTimeout( resolve(), 50 );
                        }).catch( error => {
                            alert("Netzwerkfehler! Achtung: Es kann nicht überprüft werden, ob Artikel gesperrt ist!");
                            reject(error);
                        });
                    }).catch( error => {
                        alert("Netzwerkfehler! Achtung: Es kann nicht überprüft werden, ob Artikel gesperrt ist!");
                        console.log(error);
                        reject(error);
                    });
                });
			},
            wipe() {
                //wipe all fields, start anew
                this.vendor.lastSelected = this.vendorSelected;
                this.vendorSelected = this.passedWarehouseVendor.id != 6 ? "XX" : null;
                this.condition = 1;
                this.conditionNotSelected = true,
                this.quantity = null;
                this.stockyard = null;
                this.comment = null;
                this.scannedEan = null;
                this.materialId = null;
                // this.sortVendors()
                this.$refs.refEan.focus(); //sets focus
                this.storability = {
                    materialId: null,
                    additional: false,
                    state: 0
                }
            },
            save()
            {
                //if the user is not authorized and it is not state = 1 (normal), then return;
                if( (!this.userCanDoEverything) && (this.storability.state != 1)) {
                    return;
                }

                let req = {
                    id: null,
                    ean: this.scannedEan,
                    vendorId: this.vendorSelected,
                    condition: this.condition,
                    quantity: this.quantity,
                    stockyard: this.stockyard,
                    comment: this.comment,
                    user: this.user,
                    warehouseVendorId: this.passedWarehouseVendor.id
                };

                if(this.scannedEan == '' || this.scannedEan == null)
                {
                    alert('EAN muss angegeben werden.');
                    return;
                }
                if(this.vendorSelected == '' || this.vendorSelected == null)
                {
                    alert('Lieferant muss angegeben werden.');
                    return;
                }
                if(this.condition == '' || this.condition == null)
                {
                    alert('Zustand muss angegeben werden.');
                    return;
                }
                if(this.quantity == '' || this.quantity == null)
                {
                    alert('Menge muss angegeben werden.');
                    return;
                }
                if(this.stockyard == '' || this.stockyard == null)
                {
                    alert('Lagerplatz muss angegeben werden.');
                    return;
                }
                if(this.stockyard.length > 6)
                {
                    alert('Lagerplatz darf max. 6 Zeichen sein.');
                    return;
                }
                if(this.user == '' || this.user == null)
                {
                    alert('user fehlt.');
                    return;
                }
                axios.post('/temporarywarehouselist/save', req)
                .then((response) => {
                    this.wipe();
                })
                .catch(function (error) {
                    console.log(error);
                    this.vendor.lastSelected = null;
                    this.storability = {
                        materialId: null,
                        additional: false,
                        state: 0
                    }
                    alert("Änderungen wurden aufgrund eines Fehlers verworfen.");
                });
            },

            getWarehouseListItemDebounced: function ()
            {
                if (this.scannedEan
                && this.scannedEan.toString().length > 1
                && this.condition != null)
                {
                    this.df.call();
                }
            },


        },
        watch: {
            scannedEan: function(eanNew, eanOld) {
                this.getWarehouseListItemDebounced();
            },
            condition: function(cnew, cold) {
                this.conditionNotSelected = false;
                this.getWarehouseListItemDebounced();
            },
            vendorSelected: function (cnew, cold) {
                this.getWarehouseListItemDebounced();
            }
        },
        computed: {
            validateStockyard: function() { 
                return !/^[a-z,A-Z,ö,ü,ä,Ö,Ä,Ü,ß].{0,7}$/.test(this.stockyard) 
            },
            selectedVendor(){
                if (this.vendorSelected == null || this.vendorSelected == '') return;
                return this.passedVendors.find(vendor => this.vendorSelected == vendor.id)
            }       
       },
        created()
        {
            axios.get('/user/authorization').then( response => {
                let authorization = response.data;
                console.log(authorization);
                this.userCanDoEverything = (authorization.manager
                                         || authorization.warehouse_manager
                                         || authorization.account_assistant);
            });

            // this.sortVendors();
            this.df = _.debounce(
                () => {
                    this.isMaterialStorable()
                    .then( () => {

                        axios.get('/temporarywarehouselist/getWarehouseListItem',{
                            params: {
                                scannedEan: this.scannedEan,
                                vendorId: this.vendorSelected,
                                warehouseVendorId: this.passedWarehouseVendor.id,
                                condition: this.condition
                            }
                        }).catch( error => {
                            console.log(error);
                            return;
                        }).then( response => {
                            console.log(response.data);
                            let tempArticle = response.data;

                            if ( tempArticle.twItem == null)
                            {
                                let stockStockyard = tempArticle.stockStockyard;

                                if(stockStockyard != null) {
                                    const stockyardString = stockStockyard.split("-");
                                    this.stockyard = stockyardString[0];
                                } else {
                                    this.stockyard = '';
                                }
                            }
                            else
                            {
                              this.stockyard = tempArticle.twItem ? tempArticle.twItem.stockyard : '';
                              if(this.vendorSelected == tempArticle.twItem.vendorId) {
                                this.quantity = tempArticle.twItem ? tempArticle.twItem.quantity : '';
                              } else {
                                this.quantity = '';
                              }
                            }
                            //TODO: perform CustomerOrderItem check over stockController
                          }
                        );
                    });
                },
                250,
                {
                    maxWait:650
                }
            );
            axios.get(`/mds/market`).then( response => {
                this.markets = response.data;
            }).catch( error => {
                alert("MDS Server nicht erreichbar. Es kann nicht ueberprueft werden, ob der Artikel gesperrt ist oder nicht. Bitte sofort melden.");
                console.log(error);
            });
            if(this.passedWarehouseVendor.id != 6)
            {
                this.vendorSelected = "XX";
            }
        },
        mounted()
        {
            this.$refs.refEan.focus();
        }
    }

</script>
